export default "__VITE_ASSET__Bm6jtS_y__"